import { YarnSpecReport } from './YarnSpecReport';
import { SalesOrderReportLineProcessing } from './sales-order-report-line-processing';

export interface SalesOrderConfirmationReportLine {
  productKey: string;
  productDescription: string;
  makeUp: string;
  customerProduct: string;
  customerLineRef: string;
  quantity: number;
  quantityString: string;
  unit: number;
  price: number;
  priceListUnit: string;
  discount: number;
  value: number;
  deliveryDate: Date;
  deliveryDateString: string;
  currencySymbol: string;
  contractNumber: number;
  contractBalance: number;
  orderLineNotes: string;
  deliveryNotes: string;
  returnMessage: string;

  yarnSpec: YarnSpecReport;

  salesOrderConfirmationReportLineProcessings: SalesOrderReportLineProcessing[];
}
